import { t } from 'i18next';

export default [
  {
    value: t('settings.anyone'),
    opt: 'anyone'
  },
  {
    value: t('settings.friendsOnly'),
    opt: 'friends'
  },
  {
    value: t('settings.noOne'),
    opt: 'noOne'
  }
];
